// @ts-nocheck
import type { Question } from '../types';

export const environmentalZonesQuestions: Question[] = [
  {
    id: 'q-ez-1',
    topic: 'General',
    question: 'What is a "milieuzone" (environmental zone) in the Netherlands?',
    options: [
      { id: 'q-ez-1o1', text: 'A nature reserve area' },
      { id: 'q-ez-1o2', text: 'A city center with restricted vehicle access' },
      { id: 'q-ez-1o3', text: 'A parking area for electric vehicles' },
      { id: 'q-ez-1o4', text: 'A bicycle-only zone' }
    ],
    answerId: 'q-ez-1o2',
    explanation: 'A "milieuzone" (environmental zone) is a city center area where certain vehicles are restricted from entering to improve air quality and reduce pollution.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-2',
    topic: 'General',
    question: 'Which vehicles are typically restricted in environmental zones?',
    options: [
      { id: 'q-ez-2o1', text: 'All vehicles' },
      { id: 'q-ez-2o2', text: 'Diesel vehicles and older cars' },
      { id: 'q-ez-2o3', text: 'Electric vehicles only' },
      { id: 'q-ez-2o4', text: 'Motorcycles only' }
    ],
    answerId: 'q-ez-2o2',
    explanation: 'Environmental zones typically restrict diesel vehicles and older cars that do not meet current emission standards to improve air quality.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-3',
    topic: 'General',
    question: 'What sign indicates the entrance to an environmental zone?',
    options: [
      { id: 'q-ez-3o1', text: 'A red circle with "MILIEUZONE"' },
      { id: 'q-ez-3o2', text: 'A blue circle with "MILIEUZONE"' },
      { id: 'q-ez-3o3', text: 'A green circle with "MILIEUZONE"' },
      { id: 'q-ez-3o4', text: 'A yellow triangle with "MILIEUZONE"' }
    ],
    answerId: 'q-ez-3o1',
    explanation: 'The entrance to an environmental zone is marked with a red circle containing "MILIEUZONE" to indicate restricted access.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-4',
    topic: 'General',
    question: 'What sign indicates the exit from an environmental zone?',
    options: [
      { id: 'q-ez-4o1', text: 'A red circle with "MILIEUZONE" and a diagonal line' },
      { id: 'q-ez-4o2', text: 'A blue circle with "MILIEUZONE" and a diagonal line' },
      { id: 'q-ez-4o3', text: 'A green circle with "MILIEUZONE" and a diagonal line' },
      { id: 'q-ez-4o4', text: 'A yellow triangle with "MILIEUZONE" and a diagonal line' }
    ],
    answerId: 'q-ez-4o1',
    explanation: 'The exit from an environmental zone is marked with a red circle containing "MILIEUZONE" with a diagonal line through it.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-5',
    topic: 'General',
    question: 'What is the penalty for entering an environmental zone with a restricted vehicle?',
    options: [
      { id: 'q-ez-5o1', text: 'No penalty' },
      { id: 'q-ez-5o2', text: 'A warning letter' },
      { id: 'q-ez-5o3', text: 'A fine of €95' },
      { id: 'q-ez-5o4', text: 'Vehicle confiscation' }
    ],
    answerId: 'q-ez-5o3',
    explanation: 'Entering an environmental zone with a restricted vehicle typically results in a fine of €95.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-6',
    topic: 'General',
    question: 'Which vehicles are usually exempt from environmental zone restrictions?',
    options: [
      { id: 'q-ez-6o1', text: 'All vehicles' },
      { id: 'q-ez-6o2', text: 'Emergency vehicles and electric vehicles' },
      { id: 'q-ez-6o3', text: 'Only electric vehicles' },
      { id: 'q-ez-6o4', text: 'Only emergency vehicles' }
    ],
    answerId: 'q-ez-6o2',
    explanation: 'Emergency vehicles and electric vehicles are usually exempt from environmental zone restrictions as they have low or zero emissions.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-7',
    topic: 'General',
    question: 'How can you check if your vehicle is allowed in an environmental zone?',
    options: [
      { id: 'q-ez-7o1', text: 'Check the RDW website or use the official environmental zone checker' },
      { id: 'q-ez-7o2', text: 'Ask a police officer' },
      { id: 'q-ez-7o3', text: 'Try entering and see if you get a fine' }
    ],
    answerId: 'q-ez-7o1',
    explanation: 'You can check if your vehicle is allowed in an environmental zone by using the official RDW website or environmental zone checker before entering.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-8',
    topic: 'General',
    question: 'What does the "MILIEUZONE" sign with a date indicate?',
    options: [
      { id: 'q-ez-8o1', text: 'The date the zone was established' },
      { id: 'q-ez-8o2', text: 'The date from which certain vehicles are restricted' },
      { id: 'q-ez-8o3', text: 'The date the zone will end' }
    ],
    answerId: 'q-ez-8o2',
    explanation: 'The date on a "MILIEUZONE" sign indicates from which date certain vehicles (typically older diesel vehicles) are restricted from entering.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-9',
    topic: 'General',
    question: 'What should you do if you accidentally enter an environmental zone with a restricted vehicle?',
    options: [
      { id: 'q-ez-9o1', text: 'Exit immediately and take an alternative route' },
      { id: 'q-ez-9o2', text: 'Continue driving to your destination' },
      { id: 'q-ez-9o3', text: 'Park and wait until allowed' }
    ],
    answerId: 'q-ez-9o1',
    explanation: 'If you accidentally enter an environmental zone with a restricted vehicle, exit immediately using the shortest route and take an alternative route to your destination.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-10',
    topic: 'General',
    question: 'Which cities in the Netherlands have environmental zones?',
    options: [
      { id: 'q-ez-10o1', text: 'Only Amsterdam' },
      { id: 'q-ez-10o2', text: 'Amsterdam, Rotterdam, Utrecht, and The Hague' },
      { id: 'q-ez-10o3', text: 'All major cities' }
    ],
    answerId: 'q-ez-10o2',
    explanation: 'Environmental zones exist in Amsterdam, Rotterdam, Utrecht, and The Hague. Each city may have different restrictions, so check before entering.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-11',
    topic: 'General',
    question: 'What does the Euro emission standard indicate on a vehicle?',
    options: [
      { id: 'q-ez-11o1', text: 'The year the vehicle was manufactured' },
      { id: 'q-ez-11o2', text: 'The level of pollutants the vehicle is allowed to emit' },
      { id: 'q-ez-11o3', text: 'The fuel type the vehicle uses' }
    ],
    answerId: 'q-ez-11o2',
    explanation: 'The Euro emission standard (Euro 1-6) indicates the level of pollutants a vehicle is allowed to emit. Older vehicles with lower Euro standards may be restricted from entering environmental zones.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-12',
    topic: 'General',
    question: 'How can older vehicles avoid environmental zone restrictions?',
    options: [
      { id: 'q-ez-12o1', text: 'Plan alternative routes that avoid the environmental zone' },
      { id: 'q-ez-12o2', text: 'Drive at night when restrictions are less enforced' },
      { id: 'q-ez-12o3', text: 'Pay a fee to enter the zone' }
    ],
    answerId: 'q-ez-12o1',
    explanation: 'If your vehicle does not meet environmental zone requirements, you should plan alternative routes that avoid the restricted areas. There is no fee system to bypass restrictions in Dutch environmental zones.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-13',
    topic: 'General',
    question: 'What is the purpose of environmental zones?',
    options: [
      { id: 'q-ez-13o1', text: 'To reduce traffic speeds' },
      { id: 'q-ez-13o2', text: 'To reduce air pollution and improve air quality' },
      { id: 'q-ez-13o3', text: 'To collect tolls from drivers' }
    ],
    answerId: 'q-ez-13o2',
    explanation: 'Environmental zones aim to reduce air pollution by restricting access to high-emission vehicles. This improves air quality in cities and urban areas.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-14',
    topic: 'General',
    question: 'What types of vehicles are most likely to be restricted in environmental zones?',
    options: [
      { id: 'q-ez-14o1', text: 'Electric vehicles and hybrids' },
      { id: 'q-ez-14o2', text: 'Older diesel vehicles with low Euro standards' },
      { id: 'q-ez-14o3', text: 'Small compact cars' }
    ],
    answerId: 'q-ez-14o2',
    explanation: 'Environmental zones typically restrict older diesel vehicles with low Euro emission standards (Euro 1-3). Newer vehicles and cleaner technologies are generally allowed.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-15',
    topic: 'General',
    question: 'Can you drive through an environmental zone if your vehicle does not meet the requirements?',
    options: [
      { id: 'q-ez-15o1', text: 'Yes, if you have a valid driving license' },
      { id: 'q-ez-15o2', text: 'No, you will receive a fine and a penalty' },
      { id: 'q-ez-15o3', text: 'Yes, but only during business hours' }
    ],
    answerId: 'q-ez-15o2',
    explanation: 'You cannot drive through an environmental zone with a vehicle that does not meet requirements. Doing so will result in a fine and penalty. You must use alternative routes.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-16',
    topic: 'General',
    question: 'What is the Euro 6 emission standard?',
    options: [
      { id: 'q-ez-16o1', text: 'The oldest emission standard' },
      { id: 'q-ez-16o2', text: 'The most recent and strictest emission standard' },
      { id: 'q-ez-16o3', text: 'A standard for hybrid vehicles only' }
    ],
    answerId: 'q-ez-16o2',
    explanation: 'Euro 6 is the most recent and strictest emission standard currently in effect. It applies to vehicles manufactured from 2015 onwards and limits pollutant emissions significantly.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-17',
    topic: 'General',
    question: 'How can you check your vehicle\'s Euro emission standard?',
    options: [
      { id: 'q-ez-17o1', text: 'Check the registration document or ask your mechanic' },
      { id: 'q-ez-17o2', text: 'Look at the color of the license plate' },
      { id: 'q-ez-17o3', text: 'Ask the local police' }
    ],
    answerId: 'q-ez-17o1',
    explanation: 'Your vehicle\'s Euro emission standard is listed on your vehicle registration document. You can also check online using the RDW website with your license plate number.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-18',
    topic: 'General',
    question: 'Are commercial vehicles treated differently in environmental zones?',
    options: [
      { id: 'q-ez-18o1', text: 'No, all vehicles have the same restrictions' },
      { id: 'q-ez-18o2', text: 'Yes, commercial vehicles may have exemptions' },
      { id: 'q-ez-18o3', text: 'Only private vehicles are restricted' }
    ],
    answerId: 'q-ez-18o2',
    explanation: 'Commercial and delivery vehicles may sometimes have exemptions or different restrictions in environmental zones. Check local regulations for your specific commercial vehicle.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-19',
    topic: 'General',
    question: 'What is the fine for driving through an environmental zone with a restricted vehicle?',
    options: [
      { id: 'q-ez-19o1', text: 'Warning only' },
      { id: 'q-ez-19o2', text: 'Fine of €95 to €500 depending on the city' },
      { id: 'q-ez-19o3', text: 'License points only, no fine' }
    ],
    answerId: 'q-ez-19o2',
    explanation: 'Driving through an environmental zone with a non-compliant vehicle results in fines ranging from €95 to €500 depending on which city\'s environmental zone you violate.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-20',
    topic: 'General',
    question: 'Are electric vehicles allowed in all environmental zones?',
    options: [
      { id: 'q-ez-20o1', text: 'No, they are restricted like diesel vehicles' },
      { id: 'q-ez-20o2', text: 'Yes, electric vehicles are generally exempt from restrictions' },
      { id: 'q-ez-20o3', text: 'Only during specific hours' }
    ],
    answerId: 'q-ez-20o2',
    explanation: 'Electric vehicles are generally exempt from environmental zone restrictions because they produce zero local emissions. They can usually enter any environmental zone regardless of location or time.',
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-21',
    topic: 'General',
    question: 'In residential zones, what must you observe regarding parking?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-22-residential-zone.jpg',
    options: [
      { id: 'q-ez-21o1', text: 'Park anywhere within the zone' },
      { id: 'q-ez-21o2', text: 'Park only in marked parking spaces and follow all local parking signs and regulations' },
      { id: 'q-ez-21o3', text: 'Parking is always prohibited in residential zones' }
    ],
    answerId: 'q-ez-21o2',
    explanation: 'In residential zones, you must park only in designated parking spaces and follow all posted parking signs and local regulations. Improper parking can result in fines and vehicle removal. (RVV 1990 art. 12)',
    subject: 'Environmental Zones'
  },
];
